import { createFileRoute, useParams } from '@tanstack/react-router';
import { useStore } from '../../../store';
import { CopyButton } from '../../../components/shared';
import styles from '../../../components/ProjectsView.module.css';

export const Route = createFileRoute('/projects/$projectId/overview')({
  component: OverviewTab,
});

function OverviewTab() {
  const { projectId } = useParams({ from: '/projects/$projectId/overview' });
  const projects = useStore(s => s.projects);
  const applications = useStore(s => s.applications);
  const project = projects[projectId];

  if (!project) return null;

  const projectApplications = Object.values(applications).filter(app => app.projectId === projectId);

  return (
    <div>
      <div className={styles.overviewGrid}>
        <div className={styles.overviewItem}>
          <div className={styles.overviewLabel}>Project ID</div>
          <div className={styles.overviewValue}>
            {project.id}
            <CopyButton value={project.id} aria-label="Copy Project ID" />
          </div>
        </div>
        <div className={styles.overviewItem}>
          <div className={styles.overviewLabel}>Created</div>
          <div className={styles.overviewValue}>
            {project.createdAt ? new Date(project.createdAt).toLocaleString() : 'N/A'}
          </div>
        </div>
        <div className={styles.overviewItem}>
          <div className={styles.overviewLabel}>Applications</div>
          <div className={styles.overviewValue}>{projectApplications.length}</div>
        </div>
      </div>
    </div>
  );
}
